import { createContext, useContext, Dispatch, SetStateAction } from 'react';

type DbConfigContextState = {
  json: string;
  jsonIsDirty: boolean;
  jsonIsValid: boolean;
  name: string;
  setJson: Dispatch<SetStateAction<string>>;
  setJsonIsValid: Dispatch<SetStateAction<boolean>>;
  setLastSavedJson: Dispatch<SetStateAction<string>>;
  setName: Dispatch<SetStateAction<string>>;
};

export const DB_CONFIG_CONTEXT_DEFAULT_VALUE: DbConfigContextState = {
  json: '',
  jsonIsDirty: false,
  jsonIsValid: true,
  name: '',
  setJson: () => null,
  setJsonIsValid: () => null,
  setLastSavedJson: () => null,
  setName: () => null,
};

export const DbConfigContext = createContext(DB_CONFIG_CONTEXT_DEFAULT_VALUE);
export const useDbConfigContext = () => useContext(DbConfigContext);
